import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioPerfilReducer from '../usuarioPerfil/usuarioPerfilReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import UnidadeReducer from '../unidade/unidadeReducer';
import MotoristaReducer from '../motorista/motoristaReducer';
import VeiculoTipoReducer from '../veiculoTipo/veiculoTipoReducer';
import VeiculoReducer from '../veiculo/veiculoReducer';
import ProdutoReducer from '../produto/produtoReducer';
import DistribuidoraReducer from '../distribuidora/distribuidoraReducer';
import TanqueReducer from '../tanque/tanqueReducer';
import ClienteReducer from '../cliente/clienteReducer';
import EnderecoReducer from '../cliente/endereco/enderecoReducer';
import PrecoDiaReducer from '../precoDia/precoDiaReducer';
import AdicionalDiarioReducer from '../adicionalDiario/adicionalDiarioReducer';
import FreteLitroReducer from '../freteLitro/freteLitroReducer';
import PrecoGeralReducer from '../precoGeral/precoGeralReducer';
import PoliticaPrecoReducer from '../politicaPreco/politicaPrecoReducer';
import PedidoReducer from '../pedido/pedidoReducer';
import CustoPrazoReducer from '../custoPrazo/custoPrazoReducer';
import EntradaReducer from '../entrada/entradaReducer';
import SaidaReducer from '../saida/saidaReducer';
import TransferenciaReducer from '../transferencia/transferenciaReducer';
import FreteReducer from '../frete/freteReducer';
import AnaliseCurvaPrecoReducer from '../analiseCurvaPreco/analiseCurvaPrecoReducer';
import DashboardPedidoReducer from '../dashboardPedido/dashboardPedidoReducer';
import DashboardPetroshowReducer from '../dashboardPetroshow/dashboardPetroshowReducer';
import SetorReducer from '../setor/setorReducer';
import ApontamentoGrupoReducer from '../apontamentoGrupo/apontamentoGrupoReducer';
import ApontamentoTipoReducer from '../apontamentoTipo/apontamentoTipoReducer';
import ApontamentoReducer from '../apontamento/apontamentoReducer';
import VeiculoTipoConsumoReducer from '../veiculoTipoConsumo/veiculoTipoConsumoReducer';
import MetaMotoristaReducer from '../metaMotorista/metaMotoristaReducer';
import MetaMotoristaGrupoReducer from '../metaMotoristaGrupo/metaMotoristaGrupoReducer';
import ChamadoReducer from '../chamado/chamadoReducer';
import MetaVendedorReducer from '../metaVendedor/metaVendedorReducer';
import MetaVendaReducer from '../metaVenda/metaVendaReducer';
import ProspeccaoReducer from '../prospeccao/prospeccaoReducer';
import ProspeccaoEventoReducer from '../prospeccao/prospeccaoEvento/prospeccaoEventoReducer';
import VeiculoStatusReducer from '../veiculoStatus/veiculoStatusReducer';
import PontoMapaReducer from '../pontoMapa/pontoMapaReducer';
import WhatsappReducer from '../whatsapp/whatsappReducer';
import ChecklistReducer from '../checklist/checklistReducer';
import RelatorioMovimentosReducer from '../relatorioMovimentos/relatorioMovimentosReducer';
import OficinaReducer from '../oficina/oficinaReducer';
import ManutencaoReducer from '../manutencao/manutencaoReducer';
import ManutencaoItemReducer from '../manutencaoItem/manutencaoItemReducer';
import ManutencaoAreaReducer from '../manutencaoArea/manutencaoAreaReducer';
import estoqueManualReducer from '../estoqueManual/estoqueManualReducer';
import LimiteCreditoReducer from '../limiteCredito/limiteCreditoReducer';
import VeiculoDocumentoReducer from '../veiculoDocumento/veiculoDocumentoReducer';
import ManutencaoPreventivaTipoReducer from '../manutencaoPreventivaTipo/manutencaoPreventivaTipoReducer';
import ManutencaoPreventivaReducer from '../manutencaoPreventiva/manutencaoPreventivaReducer';
import VeiculoDespesaReducer from '../veiculoDespesa/veiculoDespesaReducer';
import DashboardClienteReducer from '../dashboardCliente/dashboardClienteReducer';
import FeedbackMotoristaTipoReducer from '../feedbackMotoristaTipo/feedbackMotoristaTipoReducer';
import FeedbackMotoristaReducer from '../feedbackMotorista/feedbackMotoristaReducer';
import TesteQualidadeReducer from '../testeQualidade/testeQualidadeReducer';
import MotoristaDocumentoReducer from '../motoristaDocumento/motoristaDocumentoReducer';
import OcorrenciaLogisticaReducer from '../ocorrenciaLogistica/ocorrenciaLogisticaReducer';
import TelemetriaReducer from '../telemetria/telemetriaReducer';
import TempoDirecaoReducer from '../tempoDirecao/tempoDirecaoReducer';
import EquipamentoAlocacaoReducer from '../equipamentoAlocacao/equipamentoAlocacaoReducer';
import MetaLogisticaConfiguracaoReducer from '../metaLogisticaConfiguracao/metaLogisticaConfiguracaoReducer';
import ProcessoLogisticaReducer from '../processoLogistica/processoLogisticaReducer';
import MotoristaDiariaReducer from '../motoristaDiaria/motoristaDiariaReducer';
import MetaVendaTrimestreReducer from '../metaVendaTrimestre/metaVendaTrimestreReducer';
import MetaGerenciaSemestreReducer from '../metaGerenciaSemestre/metaGerenciaSemestreReducer';
import MetaHeitorSemestreReducer from '../metaHeitorSemestre/metaHeitorSemestreReducer';
import MetaManutencaoConfiguracaoReducer from '../metaManutencaoConfiguracao/metaManutencaoConfiguracaoReducer';
import DashboardCustoReducer from '../dashboardCusto/dashboardCustoReducer';
import CustoTipoReducer from '../custoTipo/custoTipoReducer';
import ReceitaTipoReducer from '../receitaTipo/receitaTipoReducer';
import EstoqueReducer from '../estoque/estoqueReducer';
import DenunciaReducer from '../denuncia/denunciaReducer';
import MetaBaseOperadorTrimestreReducer from '../metaBaseOperadorTrimestre/metaBaseOperadorTrimestreReducer';
import MetaBaseSupervisorTrimestreReducer from '../metaBaseSupervisorTrimestre/metaBaseSupervisorTrimestreReducer';
import DashboardEstoqueFisicoReducer from '../dashboardEstoqueFisico/dashboardEstoqueFisicoReducer';
import DespesaPlacaReducer from '../despesaPlaca/despesaPlacaReducer';
import PedidoOcorrenciaReducer from '../pedidoOcorrencia/pedidoOcorrenciaReducer';
import AnaliticaImportacaoMesReducer from '../analiticaImportacaoMes/analiticaImportacaoMesReducer';
import LocalReducer from '../local/localReducer';
import BloqueioBaseReducer from '../bloqueioBase/bloqueioBaseReducer';
import PedidoPrazoReducer from '../pedidoPrazo/pedidoPrazoReducer';
import FechamentoEstoqueDiarioReducer from '../fechamentoEstoqueDiario/fechamentoEstoqueDiarioReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	dashboardPedido: DashboardPedidoReducer,
	dashboardPetroshow: DashboardPetroshowReducer,
	usuarioPerfil: UsuarioPerfilReducer,
	usuario: UsuarioReducer,
	unidade: UnidadeReducer,
	motorista: MotoristaReducer,
	veiculoTipo: VeiculoTipoReducer,
	veiculo: VeiculoReducer,
	produto: ProdutoReducer,
	distribuidora: DistribuidoraReducer,
	tanque: TanqueReducer,
	cliente: ClienteReducer,
	endereco: EnderecoReducer,
	precoDia: PrecoDiaReducer,
	adicionalDiario: AdicionalDiarioReducer,
	freteLitro: FreteLitroReducer,
	precoGeral: PrecoGeralReducer,
	politicaPreco: PoliticaPrecoReducer,
	pedido: PedidoReducer,
	custoPrazo: CustoPrazoReducer,
	entrada: EntradaReducer,
	saida: SaidaReducer,
	transferencia: TransferenciaReducer,
	frete: FreteReducer,
	analiseCurvaPreco: AnaliseCurvaPrecoReducer,
	setor: SetorReducer,
	apontamentoGrupo: ApontamentoGrupoReducer,
	apontamentoTipo: ApontamentoTipoReducer,
	apontamento: ApontamentoReducer,
	veiculoTipoConsumo: VeiculoTipoConsumoReducer,
	metaMotorista: MetaMotoristaReducer,
	metaMotoristaGrupo: MetaMotoristaGrupoReducer,
	chamado: ChamadoReducer,
	metaVendedor: MetaVendedorReducer,
	metaVenda: MetaVendaReducer,
	prospeccao: ProspeccaoReducer,
	prospeccaoEvento: ProspeccaoEventoReducer,
	veiculoStatus: VeiculoStatusReducer,
	pontoMapa: PontoMapaReducer,
	whatsapp: WhatsappReducer,
	checklist: ChecklistReducer,
	relatorioMovimentos: RelatorioMovimentosReducer,
	oficina: OficinaReducer,
	manutencao: ManutencaoReducer,
	manutencaoItem: ManutencaoItemReducer,
	manutencaoArea: ManutencaoAreaReducer,
	estoqueManual: estoqueManualReducer,
	limiteCredito: LimiteCreditoReducer,
	veiculoDocumento: VeiculoDocumentoReducer,
	manutencaoPreventivaTipo: ManutencaoPreventivaTipoReducer,
	manutencaoPreventiva: ManutencaoPreventivaReducer,
	veiculoDespesa: VeiculoDespesaReducer,
	dashboardCliente: DashboardClienteReducer,
	feedbackMotoristaTipo: FeedbackMotoristaTipoReducer,
	feedbackMotorista: FeedbackMotoristaReducer,
	testeQualidade: TesteQualidadeReducer,
	motoristaDocumento: MotoristaDocumentoReducer,
	ocorrenciaLogistica: OcorrenciaLogisticaReducer,
	telemetria: TelemetriaReducer,
	tempoDirecao: TempoDirecaoReducer,
	equipamentoAlocacao: EquipamentoAlocacaoReducer,
	metaLogisticaConfiguracao: MetaLogisticaConfiguracaoReducer,
	processoLogistica: ProcessoLogisticaReducer,
	motoristaDiaria: MotoristaDiariaReducer,
	metaVendaTrimestre: MetaVendaTrimestreReducer,
	metaGerenciaSemestre: MetaGerenciaSemestreReducer,
	metaHeitorSemestre: MetaHeitorSemestreReducer,
	metaManutencaoConfiguracao: MetaManutencaoConfiguracaoReducer,
	dashboardCusto: DashboardCustoReducer,
	custoTipo: CustoTipoReducer,
	receitaTipo: ReceitaTipoReducer,
	estoque: EstoqueReducer,
	denuncia: DenunciaReducer,
	metaBaseOperadorTrimestre: MetaBaseOperadorTrimestreReducer,
	metaBaseSupervisorTrimestre: MetaBaseSupervisorTrimestreReducer,
	dashboardEstoqueFisico: DashboardEstoqueFisicoReducer,
	despesaPlaca: DespesaPlacaReducer,
	pedidoOcorrencia: PedidoOcorrenciaReducer,
	analiticaImportacaoMes: AnaliticaImportacaoMesReducer,
	local: LocalReducer,
	bloqueioBase: BloqueioBaseReducer,
	pedidoPrazo: PedidoPrazoReducer,
	fechamentoEstoqueDiario: FechamentoEstoqueDiarioReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

